import { TeamArea, TeamCategory, TimeZone } from '@/types/api';
import { Seniority } from '@/types/api/staffMember';

export const availabilityOptions = [
  'Immediately',
  'Within a week',
  'Within 2 and 3 weeks',
  'Within a month',
];

export const timezoneOptions = Object.keys(TimeZone).map((key) => TimeZone[key]);

export const yesOrNoOptions = ['Yes', 'No'];

export const yesOrNoBooleanOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const isEmptyOrNotEmptyOptions = ['Set', 'Not Set'];

export const englishLevelOptions = [
  { value: 'NONE', label: 'None' },
  { value: 'BASIC', label: 'Basic' },
  { value: 'CONVERSATIONAL', label: 'Conversational' },
  { value: 'FLUENT', label: 'Fluent' },
  { value: 'NATIVE_OR_BILINGUAL', label: 'Native or Bilingual' },
];

export const sourceOptions = [
  'Direct Approach on LinkedIn',
  'Consultancy',
  'DevHunt',
  'Email sent by Bot',
  'Employee Referral',
  'External Referral',
  'LinkedIn Job Application',
  'Trio Website Careers Page',
  'Unknown',
];

export const yearsOfExperienceOptions = [
  'Less than 1 year',
  '1-2 years',
  '3-4 years',
  '5-6 years',
  '7-8 years',
  '9-10 years',
  'Above 10 years',
];

export const developerTypeOptions = [
  'Front-End Developer',
  'Back-End Developer',
  'Full Stack Developer',
  'Mobile Developer',
  'QA Engineer',
  'Data Engineer',
  'Data Scientist',
  'Data Analyst',
  'DevOps Engineer',
  'AI Engineer',
  'MLOps Engineer',
  'Project Manager',
  'Blockchain Engineer',
  'Other',
];

export const countriesOptions = [
  'Brazil',
  'Argentina',
  'Ecuador',
  'Colombia',
  'Chile',
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Anguilla',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia &amp; Herzegovina',
  'Botswana',
  'British Virgin Islands',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Cape Verde',
  'Cayman Islands',
  'Chad',
  'China',
  'Congo',
  'Cook Islands',
  'Costa Rica',
  'Cote D Ivoire',
  'Croatia',
  'Cruise Ship',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Polynesia',
  'French West Indies',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kuwait',
  'Kyrgyz Republic',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macau',
  'Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Namibia',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Norway',
  'Oman',
  'Pakistan',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Pierre &amp; Miquelon',
  'Samoa',
  'San Marino',
  'Satellite',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'South Africa',
  'South Korea',
  'Spain',
  'Sri Lanka',
  'St Kitts &amp; Nevis',
  'St Lucia',
  'St Vincent',
  'St. Lucia',
  'Sudan',
  'Suriname',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  "Timor L'Este",
  'Togo',
  'Tonga',
  'Trinidad &amp; Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks &amp; Caicos',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Venezuela',
  'Vietnam',
  'Virgin Islands (US)',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

export const teamCategoryOptions: TeamCategory[] = ['Internal', 'External'];
export const teamAreaOptions: TeamArea[] = [
  'People X',
  'Engineering X',
  'Partner X',
  'Sales',
  'Talent X',
  'Marketing',
  'Finance',
];

export const seniorityOptions: Seniority[] = ['Junior', 'Mid Level', 'Senior'];
